import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

type BadStateSubmissionConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const BadStateSubmissionConfirmationModal = ({
  open,
  onClose,
  onSubmit,
}: BadStateSubmissionConfirmationModalProps) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Some tests are not passing</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have some tests that are not passing. Are you sure you want to
          submit your solution?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>
          Cancel
        </Button>
        <Button variant='contained' onClick={onSubmit} color='error'>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
